var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 582,
    viewBox: "0 0 582 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 260.5,
    stroke: "url(#paint0_linear_79_1540)",
    strokeWidth: 61
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1540",
    x1: 291,
    y1: 0,
    x2: 291,
    y2: 582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300971,
    stopColor: "#FFE3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570333,
    stopColor: "#D2D6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEEBE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.86e7bd61eec3c788dcb5b14f5db481b0.svg";
export { ForwardRef as ReactComponent };